import { useState } from "react";
import {
  launcherUrl,
  updateCasinoBalance,
} from "../../../AsianExchangeSrc/api";
import { useDispatch, useSelector } from "react-redux";
import { isMobile } from "react-device-detect";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Loader from "../../../AsianExchangeSrc/utils/Loader";
import {
  updateAvailableBalance,
  updateUserCasinoBalance,
} from "../../../AsianExchangeSrc/redux/slices/userSlice";
import { useGradientColor, usePrimaryColor, usePrimaryTextColor, useSecondaryTextColor } from "../../hooks/useThemeColors";
import { displayAuthModal } from "../../../AsianExchangeSrc/redux/slices/authModalSlice";

function GameGrid({
  gameList = [],
  categoryFilter,
  rgbColorStart,
  rgbColorEnd,
  rgbBorderColorStart,
  rgbBorderColorEnd,
}) {
  const filteredGames = gameList.filter((game) => {
    if (!categoryFilter || categoryFilter === "CASINO") return true;
    return game.category?.split("/")?.includes(categoryFilter);
  });
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [activeCard, setActiveCard] = useState(null);
  const isTouchDevice =
    typeof window !== "undefined" && "ontouchstart" in window;
  const userData = useSelector((state) => state?.user?.userData);
  const isLoggedIn = useSelector((state) => state.user.isLoggedIn);
  const siteCasinoData = useSelector((state) => state.siteCasino);
  const [loading, setLoading] = useState(false);
  const gradiantcolor = useGradientColor()
  const PrimaryColor = usePrimaryColor()
  const PrimaryTextColor = usePrimaryTextColor()
      const SecondaryTextColor = useSecondaryTextColor()
  
  const playDemo = async (gameId) => {
    localStorage.setItem("returnURL", window.location.href);
    const data = {
      gameId: gameId,
      playerId: userData?._id || "",
      displayName:
        userData?.casinoDisplayName || `Demo${Math.random() * 10000}`,
      currency: "INR",
      country: "IN",
      gender: "M",
      birthDate: "1996-10-12",
      mode: "demo",
      device: isMobile ? "mobile" : "desktop",
      returnUrl: window.location.href,
      walletSessionId: userData?.sessionToken || "",
    };

    try {
      const res = await launcherUrl(data);
      if (res.success) {
        navigate(`/game-lobby?gameId=${encodeURIComponent(res?.data?.url)}`);
      }
    } catch (error) {
      console.error(
        "Launcher error:",
        error?.response?.data?.message || error?.message || error
      );
    }
  };

  const playReal = async (gameId) => {
    if (!isLoggedIn) {
      // navigate("/login");
      dispatch(displayAuthModal("login"));
      return;
    }

    let amount = userData?.availableBalance - userData?.exposure || 0;
    let siteCasinoBalance = siteCasinoData?.casinoBalance || 0;

    let finalAmountToDeduct = Math.min(amount, siteCasinoBalance);

    if (
      finalAmountToDeduct === 0 &&
      (!userData?.casinoBalance || userData?.casinoBalance <= 0)
    ) {
      toast.warning("Insufficient balance");
      return;
    }

    try {
      setLoading(true);
      const response = await updateCasinoBalance({
        CasinoBalance: finalAmountToDeduct,
      });

      dispatch(updateAvailableBalance(response.data.user.availableBalance));

      dispatch(updateUserCasinoBalance(response.data.user.casinoBalance));
    } catch (error) {
      console.error("error", error.response?.data?.message);
    } finally {
      setLoading(false);
    }

    localStorage.setItem("returnURL", window.location.href);
    const data = {
      gameId: gameId,
      playerId: userData?._id || "",
      displayName:
        userData?.casinoDisplayName || `Demo${Math.random() * 10000}`,
      currency: "INR",
      country: "IN",
      gender: "M",
      birthDate: "1996-10-12",
      mode: "real",
      device: isMobile ? "mobile" : "desktop",
      returnUrl: window.location.href,
      walletSessionId: userData?.sessionToken || "",
    };

    try {
      const res = await launcherUrl(data);
      if (res.success) {
        navigate(`/game-lobby?gameId=${encodeURIComponent(res?.data?.url)}`);
      }
    } catch (error) {
      console.error(
        "Launcher error:",
        error?.response?.data?.message || error?.message || error
      );
    }
  };

  return (
 <div
  className="w-full h-full overflow-y-auto pb-4 bg-[url('/aura/casinobg.png')] dark:bg-none bg-cover bg-center"
>

      {loading && <Loader />}
      <div className="p-2 grid grid-cols-3 sm:grid-cols-3 md:grid-cols-6 lg:grid-cols-9 gap-3">
        {filteredGames.map((game, idx) => {
          // console.info({game});

          const bgImage = game?.images?.[2]?.url || "";
          return (
            <div
              key={idx}
              className={`relative aspect-square rounded-lg shadow-md flex flex-col justify-end overflow-hidden transition-transform transform ${
                !isTouchDevice
                  ? "hover:scale-125 hover:border-black hover:border-[4px] hover:shadow-md hover:z-50 group"
                  : ""
              } ${
                activeCard === idx
                  ? "z-50 border-black border-[4px] scale-125 shadow-md"
                  : ""
              }`}
              onClick={() => {
                if (isTouchDevice) {
                  setActiveCard(activeCard === idx ? null : idx);
                }
              }}
            >
              <div
                className="absolute inset-0 bg-cover bg-center bg-no-repeat rounded-lg"
                style={{ backgroundImage: `url(${bgImage})` }}
              ></div>

              <div
                className={`absolute inset-0 bg-black bg-opacity-50 z-20 ${
                  (!isTouchDevice && "hidden group-hover:flex") ||
                  (activeCard === idx ? "flex" : "hidden")
                } flex-col items-center justify-center gap-2 transition-opacity`}
              >
                <div
                  role="button"
                  onClick={(e) => {
                    e.stopPropagation();
                    playDemo(game.gameId);
                    // your Play Demo logic here
                  }}
                  className="bg-white text-black text-xs font-bold px-3 py-1 rounded shadow hover:bg-gray2  hover:text-white"
                >
                  Play Demo
                </div>

                <div
                  role="button"
                  onClick={(e) => {
                    e.stopPropagation();
                    playReal(game.gameId);
                  }}
                  className="bg-red-700 text-white text-xs font-bold px-3 py-1 rounded shadow hover:bg-red-600 hover:text-black"
                >
                  Play Live
                </div>
              </div>

              <div className="relative z-10 w-full text-center mt-auto flex flex-row items-center justify-center">
                <div
                  className="text-xs w-full h-full py-1 px-2 font-bold leading-none min-h-[30px]  flex flex-row items-center justify-center"
                  style={{
                    backgroundImage: PrimaryColor,
                    color: PrimaryTextColor,

                  }}
                >
                  {game.name}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default GameGrid;
